function dateISO(value) {
  if (!value) return '';
  const date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date.toISOString();
}

export default dateISO;
